import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import TenantsPage from './pages/TenantsPage';
import TenantPage from './pages/TenantPage';
import AdminPage from '../pages/AdminPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AdminPage tab="tenants" />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <TenantPage />,
      },
    ],
  },
];

export default routes;
